import axios from 'axios';

let url = '';
let statusUrl = '';
let uploadUrl = '';
let downloadUrl = '';

export const initImportExportService = (config: Record<string, any>) => {
    url = config.importExportUrl;
    statusUrl = `${url}/status`;
    uploadUrl = `${url}/upload`;
    downloadUrl = `${url}/download`;
};

export const getImportExportStatus = async () => {
    const { data } = await axios.get<ListImportExportApiResponse>(statusUrl);
    return data;
};

export const exportAllListEntries = async (payload: ExportAllListEntriesSchema): Promise<ExportAllListEntries> => {
    const { data } = await axios.post(`${url}/export`, undefined, { params: payload });
    return data;
};

export const importListEntries = async (payload: ImportListEntriesSchema): Promise<ImportListEntries> => {
    const { data } = await axios.post(`${url}/import`, { ...payload });
    return data;
};

export const uploadListFile = async (
    formData: FormData,
    abortController: AbortController,
    isUploadInitiate?: boolean
) => {
    const uploadEndpoint = !isUploadInitiate ? '/part' : '';
    const res = await axios.post(`${uploadUrl}${uploadEndpoint}`, formData, { signal: abortController.signal });
    return res;
};

/** Signals API to cancel the on-going upload/part upload on the backend
 * that was initiated by uploadListFile and revoke the uploadId */
export const cancelListFileUpload = async (payload: IMPORTER_CANCEL_FILE_UPLOAD_SCHEMA) => {
    const res = await axios.put(`${uploadUrl}/cancel`, payload);
    return res.data;
};

export const deleteUploadedListFile = async (fileName: string) => {
    const res = await axios.delete(`${uploadUrl}/remove`, { params: { fileName } });
    return res.data;
};

export const downloadListFile = async ({
    fileName,
    processType,
    isInitiateDownload,
    partNum
}: DownloadListFileSchema) => {
    const partNumber = partNum?.toString();
    const params = { fileName, processType, ...(!isInitiateDownload && { partNumber }) };
    const downloadEndpoint = !isInitiateDownload ? '/part' : '';
    const { data } = await axios.get(`${downloadUrl}${downloadEndpoint}`, {
        params,
        ...(!isInitiateDownload && { responseType: 'arraybuffer' })
    });
    return data;
};

export const cancelImportExportStatus = async ({ id, type }: CancelImportExportVariables) => {
    const { data } = await axios.put(`${url}/${type}/cancel`, null, { params: { id } });
    return data;
};
